import clienteAxios from "../config/axios";

export async function getAllSubsistema() {
    return clienteAxios.get(`/subsistema`);
}


export async function addSubsistema(subsistema) {

    return clienteAxios.post(`/subsistema`, subsistema);
}

export async function updateSubsistema(dato) {
   
    const id = dato.id
    const updates = {
        codSubsistema: dato.codSubsistema,
        name: dato.name,
        sistemaID: dato.sistemaID,

    }
    return clienteAxios.put(`/subsistema/${id}`, updates);
}

export async function deleteSubsistema(id) {
    return clienteAxios.delete(`/subsistema/${id}`);
}